import { render, staticRenderFns } from "./employment-training-education-form.vue?vue&type=template&id=f1872f8e&scoped=true"
import script from "./employment-training-education-form.vue?vue&type=script&lang=js"
export * from "./employment-training-education-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1872f8e",
  null
  
)

export default component.exports